<!-- GALLERY / INSTAGRAM -->
<section class="instagram-section section-padding">
  <div class="container">
    <div class="section-header text-center reveal-on-scroll">
      <span class="subtitle">GALLERY & INSIGHTS</span>
      <h2 class="title dark-heading">FOLLOW THE AMBITION</h2>
      <div class="gold-divider"></div>
      <p class="description dark-desc">
        See our latest projects, progress updates, design inspiration and completed homes.
      </p>
    </div>

    <div class="insta-grid">
      <div class="insta-item reveal-scale delay-1">
        <img src="/assets/images/project1/1.jpg" alt="Instagram Architectural Showcase 1">
      </div>
      <div class="insta-item reveal-scale delay-2">
        <img src="/assets/images/project1/2.jpg" alt="Instagram Architectural Showcase 2">
      </div>
      <div class="insta-item reveal-scale delay-3">
        <img src="/assets/images/project1/3.jpg" alt="Instagram Architectural Showcase 3">
      </div>
      <div class="insta-item reveal-scale delay-4">
        <img src="/assets/images/project1/4.jpg" alt="Instagram Architectural Showcase 4">
      </div>
      <div class="insta-item reveal-scale delay-5">
        <img src="/assets/images/project1/5.jpg" alt="Instagram Architectural Showcase 5">
      </div>
      <div class="insta-item reveal-scale delay-1">
        <img src="/assets/images/project1/6.jpg" alt="Instagram Architectural Showcase 6">
      </div>
    </div>

    <div class="text-center margin-top-lg reveal-on-scroll delay-2">
      <a href="https://instagram.com" target="_blank" rel="noopener" class="btn-gold btn-insta">
        FOLLOW US ON INSTAGRAM &rarr;
      </a>
    </div>
  </div>
</section>

<!-- FINAL CALL TO ACTION -->
<section id="contact" class="cta-banner-section">
  <div class="banner-bg" style="background-image: url('/assets/images/hero_home.png');">
    <div class="banner-overlay"></div>
  </div>

  <div class="container banner-content">
    <div class="banner-grid">

      <div class="text-col reveal-left">
        <h2 class="title">READY TO BUILD YOUR AMBITION?</h2>
        <p class="subtitle">
          Your dream home starts with a conversation. Whether you’re considering a custom home, knock-down rebuild or
          duplex design, we’d love to hear about your project.
        </p>

        <div class="action-btn-row">
          <button (click)="openConsultation()" class="btn-gold">
            BOOK A CONSULTATION
          </button>
        </div>
      </div>

      <div class="contact-cards-col reveal-right">
        <!-- 
        <a href="tel:0412345678" class="contact-card">
          <div class="card-icon">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path
                d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
            </svg>
          </div>
          <div class="card-info">
            <span class="info-label">PHONE INQUIRIES</span>
            <span class="info-value">0412 345 678</span>
          </div>
        </a> -->

        <a href="mailto:info@ambitionbuilt.com.au" class="contact-card">
          <div class="card-icon">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
              <polyline points="22,6 12,13 2,6" />
            </svg>
          </div>
          <div class="card-info">
            <span class="info-label">DIRECT EMAIL</span>
            <span class="info-value">info&#64;ambitionbuilt.com.au</span>
          </div>
        </a>

        <div class="contact-card">
          <div class="card-icon">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
              <circle cx="12" cy="10" r="3" />
            </svg>
          </div>
          <div class="card-info">
            <span class="info-label">PRIMARY REGION</span>
            <span class="info-value">Sydney, NSW Australia</span>
          </div>
        </div>

      </div>

    </div>
  </div>
</section>